
































































import { computed, defineComponent, getCurrentInstance, onMounted, PropType, ref, Ref } from '@vue/composition-api';
import { SearchIcon, UsergroupIcon } from 'tdesign-icons-vue';
import _ from 'lodash';

import { phoneCompose } from '@/renderer/scripts/utils/tools/index';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import { isAdminOrSuperAdmin } from '@/renderer/scripts/utils/UserRole/getters';

type MemberListItemData = SMH.UserBaseInfo & {
  checked: boolean;
  userOrgId: string;
  userId: number;
};

export default defineComponent({
  name: 'searchCreatorPopup',
  components: {
    SearchIcon,
    UsergroupIcon,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    originMember: {
      required: false,
      type: Array as PropType<Array<MemberListItemData>>,
      default: () => [],
    },
  },
  setup(props, context) {
    const { $route, $store } = getCurrentInstance()?.proxy || context.root;
    const hideSearchMember = computed(() => !$store.getters.enableViewAllOrgUser && !isAdminOrSuperAdmin.value);
    const spaceOrgId = $store.getters.orgId;
    const memberName = ref('');
    const loading = ref(false);
    const memberList = ref<Array<MemberListItemData>>([]);
    const totalMembers = ref(0);
    const innerShow = computed({
      get() {
        return props.show;
      },
      set(val) {
        context.emit('update:show', val);
      },
    });
    // 上一次勾选的成员列表
    const lastCheckedList = ref<Array<MemberListItemData>>([]);
    // 当前勾选的成员列表
    const currentCheckedList = computed(() => {
      const checkedList = memberList.value.filter((item: MemberListItemData) => item.checked);
      return checkedList;
    });
    // 记录全部已勾选的成员列表
    const checkedMemberList = computed(() => {
      // 上次勾选的+本次搜索勾选
      return Array.from(
        [...lastCheckedList.value, ...currentCheckedList.value]
          .reduce((map, item) => map.set(item.id, item), new Map())
          .values(),
      );
    });
    const methods = {
      async initData() {
        loading.value = true;
        lastCheckedList.value = checkedMemberList.value;
        try {
          const res = await smh.userAPI.getUserList({
            keyword: memberName.value,
            page: 1,
            pageSize: 1000,
            includeInactiveUser: 0,
          });
          loading.value = false;
          if (!memberName.value) {
            totalMembers.value = res.data.totalNum;
          }
          const copyMember = _.cloneDeep(lastCheckedList.value);
          memberList.value = res.data.contents.map((item: any) => {
            const index = copyMember.findIndex((item2: MemberListItemData) => item2.id === item.id);
            let checked = false;
            if (index > -1) {
              checked = true;
              copyMember.splice(index, 1);
            }
            return {
              ...item,
              checked,
              userOrgId: spaceOrgId,
              userId: item.id,
            };
          });
          // 搜索全部时拼接搜索关键词勾选的成员
          if (!memberName.value) {
            memberList.value.unshift(...copyMember);
          }
          methods.memberListSort();
        } catch (e) {
          loading.value = false;
          tips.error(e as MsgError);
        }
      },
      onSearchMember() {
        methods.initData();
      },
      clearSearchMember() {
        memberName.value = '';
        methods.initData();
      },
      handleSelectItem(item: MemberListItemData) {
        lastCheckedList.value.forEach((val: MemberListItemData, index) => {
          if (val.id === item.id && !item.checked) {
            lastCheckedList.value.splice(index, 1);
          }
        });
      },
      onCancel() {
        innerShow.value = false;
      },
      onConfirm() {
        context.emit('onSubmit', checkedMemberList.value, totalMembers.value, hideSearchMember.value);
      },
      memberListSort() {
        // 勾选的排序在前
        memberList.value.sort((a: MemberListItemData, b: MemberListItemData) => {
          if (a.checked && !b.checked) return -1;
          return 1;
        });
      },
    };
    onMounted(async () => {
      await methods.initData();
      if (
        props.originMember.length !== 0 &&
        (props.originMember.length !== totalMembers.value || hideSearchMember.value)
      ) {
        const copyMember = [...props.originMember];
        memberList.value.forEach((item: MemberListItemData) => {
          const index = copyMember.findIndex(
            (memberItem: MemberListItemData) =>
              memberItem.userId === item.userId && memberItem.userOrgId === item.userOrgId,
          );
          if (index > -1) {
            item.checked = true;
            copyMember.splice(index, 1);
          }
        });
        // 如果有剩余，那就是隐藏的成员，需要添加到 list 中
        memberList.value.unshift(...copyMember);
      }
      methods.memberListSort();
    });
    return {
      hideSearchMember,
      loading,
      phoneCompose,
      memberList,
      memberName,
      checkedMemberList,
      ...methods,
    };
  },
});
